export const theme = {
  fonts: {
    primary: "'IBM Plex Sans', 'Helvetica Neue', sans-serif",
    display: "'Bricolage Grotesque', 'Helvetica Neue', sans-serif",
  },
  colors: {
    primary: "#42634A",
    primaryHover: "#294633",
    secondary: "#BA7656",
    cream: "#F3F0E8",
    neutral: "#E7E9E1",
    ink: "#18231C",
    text: "#18231C",
    muted: "#657067",
    border: "#CDD3CA",
    white: "#FFFFFF",
  },
  radius: "18px",
  shadow: "0 24px 70px rgba(24,35,28,.10)",
  maxw: "1320px",
};
